module.exports = __webpack_public_path__ + "img/C户型品鉴-右_image.ecb99802.png";